import React, { useState, useEffect } from 'react';
import { FaTimes, FaBars } from 'react-icons/fa';
import { HashLink } from 'react-router-hash-link';
import { NavLink } from 'react-router-dom';
import './Header.css';
import logo from '../../assets/img/header/logo.png';
import { IoIosArrowUp } from "react-icons/io";

function Header({ handleLanguageChange, selectedLanguage }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Scroll‐spy for section highlights (optional)
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.pageYOffset;
      document.querySelectorAll('section[id]').forEach(current => {
        const top = current.offsetTop - 58;
        const height = current.offsetHeight;
        const id = current.id;
        const link = document.querySelector(`.nav__menu a[href*="${id}"]`);
        if (link) {
          link.classList.toggle(
              'active-link',
              scrollY >= top && scrollY < top + height
          );
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
      <header className="header" id="header">
        <nav className="nav container">
          <HashLink to="/#hero" className="nav__logo">
            <img src={logo} className="nav__logo-icon" alt="nav logo" />
          </HashLink>

          <div className={`nav__menu ${menuOpen ? 'show-menu' : ''}`} id="nav-menu">
            <ul
                className="nav__list"
                dir={selectedLanguage === 'fa' ? 'rtl' : 'ltr'}
            >
              <li className="nav__item">
                <NavLink
                    to="/"
                    end
                    className={({ isActive }) => `nav__link${isActive ? ' active-link' : ''}`}
                    onClick={() => setMenuOpen(false)}
                >
                  Home
                </NavLink>
              </li>

              <li className="nav__item">
                <NavLink
                    to="/about-us"
                    className={({ isActive }) => `nav__link${isActive ? ' active-link' : ''}`}
                    onClick={() => setMenuOpen(false)}
                >
                  About Us
                </NavLink>
              </li>

              <li className="nav-dropdown-box" onClick={() => setDropdownOpen(!dropdownOpen)}>
              <span className="nav__link">
                Services
                <IoIosArrowUp className={`nav__dropdown-icon ${dropdownOpen ? 'rotate' : ''}`} />
              </span>
                {dropdownOpen && (
                    <ul className="nav__dropdown">
                      {[
                        ['player-support', 'Player Support'],
                        ['file-complaint', 'File Complaint'],
                        ['license-support-services', 'License Support Services'],
                        ['license-register', 'License Register'],
                      ].map(([path, label]) => (
                          <li key={path}>
                            <NavLink
                                to={`/${path}`}
                                className={({ isActive }) =>
                                    `nav__dropdown-link${isActive ? ' active-link' : ''}`
                                }
                                onClick={() => {
                                  setMenuOpen(false);
                                  setDropdownOpen(false);
                                }}
                            >
                              {label}
                            </NavLink>
                          </li>
                      ))}
                    </ul>
                )}
              </li>

              <li className="nav__item">
                <NavLink
                    to="/contact-us"
                    className={({ isActive }) => `nav__link${isActive ? ' active-link' : ''}`}
                    onClick={() => setMenuOpen(false)}
                >
                  Contact
                </NavLink>
              </li>
            </ul>

            <div className="nav__close" onClick={() => setMenuOpen(false)}>
              <FaTimes />
            </div>
          </div>

          <div className="nav__btns">
            <div
                className="nav__toggle"
                onClick={() => setMenuOpen(open => !open)}
                aria-label="Toggle Menu"
            >
              <FaBars />
            </div>
          </div>
        </nav>
      </header>
  );
}

export default Header;
